import React from 'react';
import PropTypes from 'prop-types';

export default function Line(_ref) {
  var line = _ref.line,
      layer = _ref.layer,
      scene = _ref.scene,
      catalog = _ref.catalog,
      isDesktop = _ref.isDesktop;


  var renderedLine = catalog.getElement(line.type).renderAxonomertic ? catalog.getElement(line.type).renderAxonomertic(line, layer) : null;

  return React.createElement(
    'g',
    null,
    renderedLine
  );
}

Line.propTypes = {
  line: PropTypes.object.isRequired,
  layer: PropTypes.object.isRequired,
  scene: PropTypes.object.isRequired,
  catalog: PropTypes.object.isRequired,
  isDesktop: PropTypes.bool.isRequired
};